export default {"src":"/_next/static/media/banner.f32023f9.svg","height":920,"width":1330,"blurWidth":0,"blurHeight":0};